<div class="container">
  <div class="stepper">
    <div class="stepContainer active">
      <div class="step">1</div>
    </div>
    <div class="stepContainer">
      <div class="step">2</div>
    </div>
    <div class="stepContainer">
      <div class="step">3</div>
    </div>
    @if (shouldDisplayFourthStep()) {
      <div class="stepContainer">
        <div class="step">4</div>
      </div>
    }
  </div>
  <div class="videoContainer">
    <div class="videoTitle">{{ "onboarding.1.title" | translate }}</div>
    <div class="videoBlock">
      <video class="video" controls playsinline webkit-playsinline>
        <source
          src="https://bedici.s3.fr-par.scw.cloud/illustrations/intro/BeDiCi_version_courte.mp4"
          type="video/mp4"
          />
      </video>
    </div>
  </div>
  <div class="lineContainer marginTop row">
    <div class="col-12 col-md-4">
      <div (click)="next()" class="nextButton">
        {{ "common.buttons.next" | translate }}
      </div>
    </div>
  </div>
</div>
